const activeModifier = 'is-active';

const NavSearch = class {

    constructor() {
        this.$form = $('.js-nav-search');

        if (this.$form.length < 1) {
            return;
        }

        this.$input = this.$form.find('.js-input');
        this.$reset = this.$form.find('.js-reset-input');
        this.$toggle = $('.js-nav-search-toggle');

        this.addEventListeners();
    }

    addEventListeners() {
        this.$toggle.on('click', () => {
            this.handleToggle();
        });

        this.$reset.on('click', (event) => {
            event.preventDefault();
            this.resetInput();
        });
    }

    handleToggle() {
        if (!this.$form.hasClass(activeModifier)) {
            this.$form.addClass(activeModifier);
            document.body.classList.add('nav-search-active');
            this.$input.focus();
        } else {
            document.body.classList.remove('nav-search-active');
            this.$form.removeClass(activeModifier);
        }
    }

    resetInput() {
        this.$input.val('');
        this.$form.removeClass(activeModifier);
        document.body.classList.remove('nav-search-active');
    }
};

new NavSearch();
